export const Footer = () => {
  return (
    <div id="footer">
        <div
          className="container text-center"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            padding: "1rem 0",
          }}
        >
          <img
            src="/img/logo/tahil_logo_vector.png"
            alt="Tahıl Logo"
            loading="lazy"
            style={{
              height: "40px",
              opacity: 0.7,
              transition: "opacity 0.3s ease",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.7)}
          />

          <div
            style={{
              width: "1px",
              height: "40px",
              backgroundColor: "#aaa",
              opacity: 0.5,
            }}
          />

          <p style={{ margin: 0, fontSize: "1rem", color: "#555" }}>
            &copy; 2025 Tahil Group Canada Company
          </p>
        </div>
      </div>
  )
}